import { Autocomplete, Button, Chip, Grid, OutlinedInput, Stack, TextField } from "@mui/material";
import React from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useTranslation } from "react-i18next";

export type AddPriceProps = {
  context: "TABLE" | "APART";
  price: any;
  options: any;
  disabled: boolean;
  onCurrencySelection: (value: any) => void;
  onCurrencyAdd: () => void;
  onPriceAdd: (price: any, value: any) => void;
  onPriceRemove: (price: any) => void;
};

const AddPrice: React.FC<AddPriceProps> = (props) => {
  const { t } = useTranslation();
  const { context, price, options, disabled, onCurrencySelection, onCurrencyAdd, onPriceAdd, onPriceRemove } = props;

  return (
    <Stack>
      <Grid container spacing={1} pt={0} mb={1}>
        <Grid item md={8} pt={0}>
          <Autocomplete
            options={price}
            onChange={(e, value) => {
              if (value && value !== null) {
                onCurrencySelection(value);
              }
            }}
            renderInput={(params) => <TextField {...params} />}
            sx={{ pt: 0 }}
          />
        </Grid>
        <Grid item md={4}>
          <Button
            size="small"
            color="primary"
            variant="contained"
            // sx={{ height: 40 }}
            sx={{ mt: 3, width: 100, height: 40 }}
            onClick={() => {
              onCurrencyAdd();
            }}
            disabled={disabled} // || !data.selectedCurrency
          >
            {t("button:addPrice")}
          </Button>
        </Grid>
      </Grid>

      {options?.map((price) => (
        <Grid container spacing={1} mb={1}>
          <Grid item md={5}>
            <OutlinedInput
              value={price.price}
              sx={{ width: "100%" }}
              type="number"
              onChange={(value) => onPriceAdd(price, value)}
            />
          </Grid>
          <Grid item md={3} sx={{ maxWidth: "fit-content !important" }}>
            <Chip
              label={price.currency}
              size="medium"
              sx={context === "TABLE" ? { height: "40px" } : { height: "40px", mt: 3 }}
            />
          </Grid>
          <Grid item md={0.5}>
            <ClearIcon
              sx={context === "TABLE" ? { mt: 0.8 } : { mt: 3.8 }}
              color="error"
              onClick={() => onPriceRemove(price)}
            />
          </Grid>
        </Grid>
      ))}
    </Stack>
  );
};

export default AddPrice;
